import { Action, any, IOWidget, mkWidget, Pair, nothing, mk_widget, Widget, async } from 'widgets-for-react'
import React from 'react'
import Plyr from 'react-plyr'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { CMSState, BlockData } from '../../cms/blocks/types.gen'
import { CustomBlockData, isCustomBlockData, renderCustomBlock } from './custom_blocks/types.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { FeaturedContentBlockProps, FeaturedContentBlockStyle } from '../../cms/blocks/widgets/featuredContentBlock.gen'
import { getMockedBlockRenderer, BlocksRenderer, renderBlock } from '../../cms/blocks/block_to_widget.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { TemplateState, Page } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { postOverview } from '../templates/post_overview.mod'

let myFeauredContentBlock = (
  itemsOptions: Array<
    Pair<FeaturedContentBlockProps<CustomBlockData, ExtraImages>, { style?: FeaturedContentBlockStyle; key?: string }>
  >
): IOWidget<
  CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>,
  Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>
> => {
  return s =>
    mkWidget({
      run: setstate => {
        return (
          <div>
            This is a custom renderer for a default block of kind <b>featuredContentComponent</b>
            {itemsOptions.map(i => (
              <div>
                <div>
                  <i>title:</i> <b>{i.fst.title}</b>{' '}
                </div>
                <div>
                  <i>image location:</i> <b>{i.fst.imageLocation}</b>{' '}
                </div>
                <div>
                  <i>image id:</i> <b>{i.fst.image}</b>{' '}
                </div>
                <div>
                  <i>image image_size:</i> <b>{i.fst.image_size}</b>{' '}
                </div>
                <div>
                  <i>intro:</i> <b>{i.fst.intro}</b>{' '}
                </div>
              </div>
            ))}
          </div>
        )
      }
    })
}

export let blocks_renderer = <customBlockData, extra_images, customPageData>() => ({
  ...getMockedBlockRenderer<customBlockData, extra_images, customPageData>()
  // featuredContentComponent:myFeauredContentBlock
})

export function pageDisplay_AUX(
  blocks: (Block | CustomBlock)[],
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>,
  public_state:PublicSiteState
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return s => {

    const render_block = (b: CustomBlockData | BlockData<CustomBlockData, ExtraImages>, index: number) => 
    isCustomBlockData(b)
      ? renderCustomBlock(b, public_state, `key-${index}`)(s).map<
          Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
        >(a => s1 => {
          let res = a(s1)
          return { ...s1, images: res.images, blocks: res.blocks, custom_page_data: res.custom_page_data }
        })
      : renderBlock(b, blocks_renderer, `key-${index}`)(s).map<
          Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
        >(a => s1 => {
          let res = a(s1)
          return { ...s1, images: res.images, blocks: res.blocks }
        })
        
    let header = s.blocks.find(b => b.kind == 'headerBlock')
    return s.page.kind == 'loaded' &&
          s.page.value.extra_data.post.type == 'page' &&
          (s.page.value.extra_data.post.template == 'news-overview' || s.page.value.extra_data.post.template == 'story-overview')
        ? any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
            render_block(header, s.blocks.keyOf(header)),
            postOverview(s.page.value, s.page.value.extra_data.post.template == 'news-overview' ? 'news' : 'story'),
            ...s.blocks
              .filterNot(b => b.kind == 'headerBlock')
              .map((b, index) => render_block(b, index))
              .valueSeq()
              .toArray()
          ])
        : any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
          ...s.blocks
            .map((b, index) => render_block(b, index))
            .valueSeq()
            .toArray()
      ])

  }
}
  
export let pageDisplay = (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
): ((
  b: (Block | CustomBlock)[],
  public_state:PublicSiteState
) => IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
>) => (b, public_state) => pageDisplay_AUX(b, blocks_renderer, public_state)
